module.exports = __webpack_public_path__ + "static/img/gzzShade3.1c72cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/gzzShade3.png
// module id = eePX
// module chunks = 2